import React, { Component } from 'react';
import { connect } from 'shalala';
import { Link } from 'react-router-dom';

import { useStore } from '../../store';
import Loading from '../../facturotopia/loading/Loading';
import RetencionStatusInfo from './info/components/RetencionStatusInfo';
import RetencionGeneralInfo from './info/components/RetencionGeneralInfo';

class RetencionesInfo extends Component {

  state = {}

  constructor(props) {
    super(props);

    const { data = {}} = props.location.state || {};
    const { uuid } = props.match.params;

    this.state = {
      data: !!data.uuid ? { ...data } : { uuid }
    }
  }

  componentDidMount() {
    const { uuid } = this.state.data;

    this.props.info(uuid);
  }

  render() {
    const { data = {}, busy } = this.props;

    if (busy) {
      return <Loading />
    }

    return (
      <>
        <div className="page-header">
          <Link to="/app/retenciones">
            &#8592; Retenciones
          </Link>
        </div>

        <h5>
          { data.uuid }
        </h5>

        { !!data.uuid && (
            <div>
              <RetencionStatusInfo data={ data } />

              <div className="d-block mt-3 mb-2">
                <strong className="text-muted">Detalles</strong>
              </div>

              <RetencionGeneralInfo data={ data } />

            </div>
          )
        }
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return state.app.retenciones.info;
}

const mapActionsToProps = (actions) => {
  return actions.app.retenciones.info;
}

export default connect(useStore, mapStateToProps, mapActionsToProps)(RetencionesInfo);